export default "__VITE_ASSET__CtYtKc$X__"